import { SYNC_KEY_CATALOGOS_ESTADOS_FENOLOGICOS } from "../../../constantes";
import { CatalogosPlataformaService } from "../../generated/grpc/plataforma_catalogos_pb";
import { MonitoreoEstadoFenologicoResponse } from "../../response/comun/MonitoreoEstadoFenologicoResponse";
import { ServiceGetListBase } from "../base/ServiceGetListBase";
import { grpcCall, grpcClient } from "../grpc/grpcCall";

/** Catálogo de estados fenológicos (página Monitoreo → Estados fenológicos). */
export class MonitoreoEstadoFenologicoService extends ServiceGetListBase<MonitoreoEstadoFenologicoResponse> {
  static readonly instance = new MonitoreoEstadoFenologicoService();
  private constructor() { super(); }

  /** Clave única del listado: deduplica `sync()` (dos pedidos simultáneos, un solo request). */
  protected readonly syncKey = SYNC_KEY_CATALOGOS_ESTADOS_FENOLOGICOS;

  /** gRPC-Web (`CatalogosPlataformaService.ListEstadosFenologicos`): sin eliminados, por orden. */
  protected async fetchItems(): Promise<MonitoreoEstadoFenologicoResponse[]> {
    const response = await grpcCall(() => grpcClient(CatalogosPlataformaService).listEstadosFenologicos({}));
    return response.items.map((e) => ({
      id: e.id,
      isEliminado: false,
      orden: e.orden,
      codigo: e.codigo,
      descripcion: e.descripcion,
    }));
  }
}
